import BaseService from './base.service'
const API_URL = process.env.VUE_APP_API_URL
// interface ResultsPayload {
//     account: string,
//     game?: string,
//     search?: string,
// }
class ResultService extends BaseService {
    getResults(page, per_page, game, search) {
        return this.post(API_URL + `api/lotto/results?page=${page}&per_page=${per_page}&game_slugs=${game}&search=${search?search:""}`, {}).then((response) => {
            return response.data
        })
    }
}

export default new ResultService()
